import { defaultConfig } from '@formkit/vue'
import { primeInputs } from '@sfxcode/formkit-primevue'

export default defaultConfig({
    inputs: primeInputs
})
